import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IDiscussionGuideQuestion } from '../../../models/data-capture.models';

@Component({
  selector: 'app-edit-sheet-confirmation',
  template: `
    <div class="flex justify-between content-center">
      <h3 mat-dialog-title>Generate new answers for your edited questions?</h3>
      <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-dialog-content>
      <form [formGroup]="modifyQuestionForm" class="flex flex-col gap-8">
        <span>
          The following questions have been edited. Select the ones you'd like
          to generate new answers for. This will
          <b>replace any existing responses</b> in your Data Capture sheet.
        </span>

        <div class="flex flex-col gap-2">
          <b>Edited questions:</b>

          <div formArrayName="modifiedQuestions" class="flex flex-col gap-4">
            @for (
              question of modifiedQuestions;
              track question;
              let i = $index
            ) {
              <mat-checkbox [formControlName]="i">
                {{ question.question }}
              </mat-checkbox>
            }
          </div>
        </div>
      </form>
    </mat-dialog-content>

    <mat-dialog-actions class="flex gap-2">
      <button
        type="button"
        mat-stroked-button
        mat-dialog-close
        color="primary"
        class="flex-1 primaryColor-border"
      >
        Go back
      </button>
      <button
        class="flex-1"
        type="submit"
        mat-flat-button
        color="primary"
        (click)="confirmEdit()"
      >
        Confirm
      </button>
    </mat-dialog-actions>
  `,
  styles: `
    .error {
      color: red;
    }
    h3 {
      margin-bottom: 0;
    }
  `,
  standalone: false,
})
export class EditSheetConfirmationComponent implements OnInit {
  modifyQuestionForm: FormGroup<{
    modifiedQuestions: FormArray<FormControl<boolean>>;
  }>;

  get modifiedQuestionsArray() {
    return this.modifyQuestionForm.controls.modifiedQuestions;
  }

  constructor(
    private dialogRef: MatDialogRef<EditSheetConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA)
    public modifiedQuestions: IDiscussionGuideQuestion[]
  ) {}

  ngOnInit(): void {
    this.modifyQuestionForm = new FormGroup({
      modifiedQuestions: new FormArray(
        this.modifiedQuestions.map(() => new FormControl<boolean>(false))
      ),
    });
  }

  confirmEdit() {
    if (this.modifyQuestionForm.invalid) {
      this.modifyQuestionForm.markAllAsTouched();
      return;
    }

    const selectedQuestionIds = this.modifiedQuestions
      .filter((_, i) => this.modifiedQuestionsArray.at(i).value)
      .map((q) => q.question_id);

    this.dialogRef.close(selectedQuestionIds);
  }
}
